import styled, { css } from "styled-components";

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

interface IContainer {
  isfocus?: string;
};

export const Container = styled.div<IContainer>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  border-radius: 5px;
  border: 1px dashed ${({ theme }) => theme.colors.surface.surfaceOutline};
  padding: 16px 12px;

  .uploadIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    
    ${({ isfocus }) => isfocus === 'true' && css`
      color: ${({ theme }) => theme.colors.primary.primary} !important;
    `}
  }

  .infoText {
    font-size: 12px;
    font-weight: 600;
    line-height: 16.34px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    margin-top: 12px;
  }

  .infoSubText {
    font-size: 10px;
    font-weight: 400;
    line-height: 13.62px;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    margin: 6px 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

interface IImgCard {
  isprogress?: string;
  haserror?: string;
}

export const ImgCard = styled.div<IImgCard>`
  width: 100%;
  height: 72px;
  min-height: 72px;
  max-height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  margin-top: 12px;

  &+& {
    margin-top: 6px;
  }
  
  .image {
    position: relative;
    width: 96px;
    height: 72px;
    
    img {
      width: 96px;
      min-width: 96px;
      max-width: 96px;
      height: 72px;
      min-height: 72px;
      max-height: 72px;
      object-fit: contain;
      z-index: 1;
    }
    
    .progressBar {
      position: absolute;
      bottom: 0;
      left: 0;
      padding-left: 10px;
      margin-bottom: 0;
      z-index: 2;
    }
  
    ${({ isprogress }) => isprogress === 'true' && css`
      .progressMask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #000000;
        opacity: 0.5;
        z-index: 3;
      }
    `}
  
    ${({ haserror }) => haserror === 'true' && css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 96px;
      min-height: 72px;
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.danger.dangerContainer}, ${theme.colors.surface.surface})`};
    `}
  }


  .imgContent {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-left: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    padding: 0 16px;

    .imgTextContent {
      width: 100%;
      display: flex;
      flex-direction: column;
      white-space: normal;
      overflow: hidden;
      justify-content: center;

      .textName {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px; 
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }

      .textSize {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px; 
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        margin-top: 4px;
      }

      .imgTextCreatorContent {
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin-top: 4px;

        .textCreator {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px; 
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
          margin-left: 6px;
        }
      }

      ${({ haserror }) => haserror === 'true' && css`
        .textName {
          color: ${({ theme }) => theme.colors.danger.danger};
        }
        .textSize {
          color: ${({ theme }) => theme.colors.danger.danger};
        }
      `}
    }

    .buttonCancelOrDelete {
      width: 28px !important;
      height: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ theme }) => theme.colors.secondary.secondary} !important;

      .iconCancelOrDelete {
        color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
      }
    }
  }
`;
